import { FaSearch, FaTimes } from "react-icons/fa";
import "./name-search.css";

interface NameSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export const NameSearch = ({ value, onChange }: NameSearchProps) => (
  <div className="name-search">
    <label className="name-search__field">
      <FaSearch aria-hidden="true" />
      <input
        type="search"
        aria-label="Pesquisar pelo nome"
        placeholder="Pesquisar pelo nome"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </label>
    {value && <button type="button" aria-label="Limpar pesquisa" onClick={() => onChange("")}><FaTimes aria-hidden="true" /></button>}
  </div>
);
